import {
  BodyText,
  Card,
  CardContent,
  NextButton,
  Spinner,
} from '@cint/wonderment';
import { useDropzone } from 'react-dropzone';

interface FileUploadInputProps {
  onDrop: (acceptedFiles: any, rejectedFiles: any) => Promise<void> | void;
  isUploading: boolean;
}

export const FileUploadInput = ({
  isUploading,
  onDrop,
}: FileUploadInputProps) => {
  const {
    open: openBrowseFiles,
    getRootProps,
    getInputProps,
  } = useDropzone({
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.ms-excel': ['.csv'],
      'text/plain': ['.csv'],
    },
    noClick: true,
    maxFiles: 1,
    onDrop,
    multiple: false,
  });

  return (
    <Card className="mb-6 min-h-50 justify-center items-center">
      <CardContent>
        {isUploading ? (
          <Spinner size="md" />
        ) : (
          <div
            {...getRootProps({
              className:
                'dropzone w-full h-full flex flex-col items-center justify-center',
            })}
          >
            <input data-testid="file-input" {...getInputProps()} />
            <div className="w-full h-full flex flex-col items-center justify-center">
              <BodyText className="mb-6">Drop files here to upload.</BodyText>
              <NextButton
                size="base"
                text="Browse files"
                variant="outline"
                onClick={openBrowseFiles}
              />
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
